// src/components/layout/sidebar/menuItems.ts
import {
  LayoutDashboard,
  Users,
  Shield,
  Building2,
  UserCog,
  FileSpreadsheet,
  Package,
  Plane,
  FileCheck,
  Link2,
  UserPlus,
  AlertCircle,
  Hotel,
  Clock,
  Eye,
  Tent,
  Settings,
  History,
  Wallet,
  FileText,
  Calendar,
  ArrowUpCircle,
  List,
  Radio,
  FileImage,
  WalletCards,
  Info,
  BedDouble
} from 'lucide-react';

// Menu items for admin role
const adminMenuItems = (translations: any = {}) => [
  {
    path: '/',
    icon: LayoutDashboard,
    label: translations?.menu?.dashboard || 'Dashboard',
    group: 'dashboard',
  },
  /*
  {
    path: '/timeline',
    icon: Calendar,
    label: translations?.menu?.timeline || 'Project Timeline',
    group: 'dashboard',
  },
  */
  {
    path: '/pilgrims',
    icon: FileSpreadsheet,
    label: translations?.menu?.pilgrims || 'Pilgrims',
    group: 'management',
  },
  {
    path: '/pilgrims-informations',
    icon: Info,
    label: translations?.menu?.pilgrimsInformations || 'Pilgrims Informations',
    group: 'management',
  },
  {
    path: '/packages',
    icon: Package,
    label: translations?.menu?.packages || 'Packages',
    group: 'management',
  },
  {
    path: '/flights',
    icon: Plane,
    label: translations?.menu?.flights || 'Flights',
    group: 'management',
  },
  {
    path: '/verification',
    icon: FileCheck,
    label: translations?.menu?.verification || 'Verification',
    group: 'management',
  },
  {
    path: '/verification-approval',
    icon: FileCheck,
    label: translations?.menu?.verificationApproval || 'Verification Approval',
    group: 'management',
  },
   {
     path: '/passport-visa',
     icon: FileImage,
     label: translations?.menu?.passportVisa || 'Passport & Visa',
     group: 'management',
   },
   {
     path: '/pilgrim-guide',
     icon: UserPlus,
     label: translations?.menu?.pilgrimGuide || 'Pilgrim Guide',
     group: 'linking',
   },
  /*
  {
    path: '/my-operation-list',
    icon: List,
    label: translations?.menu?.operationList || 'Operation List',
    group: 'linking',
  },
  */
  /*
  {
    path: '/operator-helper',
    icon: Radio,
    label: translations?.menu?.operatorHelper || 'Operator Helper',
    group: 'linking',
  },
  */
  /*
  {
    path: '/operation-taker',
    icon: Radio,
    label: translations?.menu?.operationTaker || 'Operation Taker',
    group: 'linking',
  },
  */
  // TODO: re-enable "حالة الربط" (Linking Status) once this page's stats are
  // reconciled with computeOrgStats (src/lib/orgStats.ts). Hidden temporarily
  // so staff don't rely on numbers that contradict /organizers-overview.
  // {
  //   path: '/linking-status',
  //   icon: Link2,
  //   label: translations?.menu?.linkingStatus || 'Linking Status',
  //   group: 'linking',
  // },
  /*
  {
    path: '/operator-overview',
    icon: Radio,
    label: translations?.menu?.operatorOverview || 'Operator Overview',
    group: 'linking',
  },
  */
  {
    path: '/disputes',
    icon: AlertCircle,
    label: translations?.menu?.disputes || 'Disputes',
    group: 'linking',
  },
  /*
  {
    path: '/organizer-finance',
    icon: Wallet,
    label: translations?.menu?.organizerFinance || 'Organizer Finance',
    group: 'linking',
  },
  */
  /*
  {
    path: '/accommodationTasks',
    icon: Hotel,
    label: translations?.menu?.accommodationTasks || 'Accommodation Tasks',
    group: 'accommodation',
  },
  */
  /*
  {
    path: '/accommodation',
    icon: Hotel,
    label: translations?.menu?.accommodation || 'Hotel Accommodation',
    group: 'accommodation',
  },
  */
  /*
  {
    path: '/hotel-visualization',
    icon: Eye,
    label: translations?.menu?.hotelVisualization || 'Hotel Visualization',
    group: 'accommodation',
  },
  */
  /*
  {
    path: '/movements',
    icon: Clock,
    label: translations?.menu?.movements || 'Movements',
    group: 'accommodation',
  },
  */
  /*
  {
    path: '/room-upgrade',
    icon: ArrowUpCircle,
    label: translations?.menu?.roomUpgrade || 'Room Upgrades',
    group: 'accommodation',
  },
  */
  /*
  {
    path: '/room-type-switch',
    icon: BedDouble,
    label: translations?.menu?.roomTypeSwitch || 'Room Type Switch',
    group: 'accommodation',
  },
  */
  {
    path: '/team',
    icon: Users,
    label: translations?.menu?.team || 'Team',
    group: 'settings',
  },
  {
    path: '/roles',
    icon: Shield,
    label: translations?.menu?.roles || 'Roles',
    group: 'settings',
  },
  {
    path: '/bans',
    icon: Shield,
    label: translations?.menu?.bans || 'Bans Management',
    group: 'settings',
  },
  {
    path: '/organizers',
    icon: Building2,
    label: translations?.menu?.organizers || 'Organizers',
    group: 'settings',
  },
  {
    path: '/guides',
    icon: UserCog,
    label: translations?.menu?.guides || 'Guides',
    group: 'settings',
  },
  {
    path: '/organizers-overview',
    icon: Building2,
    label: translations?.menu?.organizersOverview || 'Organizers Overview',
    group: 'settings',
  },
  {
    path: '/settings',
    icon: Settings,
    label: translations?.menu?.settings || 'Settings',
    group: 'settings',
  },
];

 // Menu items for guide role
const guideMenuItems = (translations: any = {}) => [
  {
    path: '/',
    icon: LayoutDashboard,
    label: translations?.menu?.dashboard || 'Dashboard',
    group: 'dashboard',
  },
  /*
  {
    path: '/timeline',
    icon: Calendar,
    label: translations?.menu?.timeline || 'Project Timeline',
    group: 'dashboard',
  },
  */
   {
     path: '/passport-visa',
     icon: FileImage,
     label: translations?.menu?.passportVisa || 'Passport & Visa',
     group: 'management',
   },
   {
     path: '/pilgrim-guide',
     icon: UserPlus,
     label: translations?.menu?.pilgrimGuide || 'Pilgrim Guide',
     group: 'management',
   },
  /*
  {
    path: '/my-operation-list',
    icon: List,
    label: translations?.menu?.operationList || 'Operation List',
    group: 'management',
  },
  */
  /*
  {
    path: '/operator-helper',
    icon: Radio,
    label: translations?.menu?.operatorHelper || 'Operator Helper',
    group: 'management',
  },
  */
  /*
  {
    path: '/operation-taker',
    icon: Radio,
    label: translations?.menu?.operationTaker || 'Operation Taker',
    group: 'management',
  },
  */
  /*
  {
    path: '/operator-overview',
    icon: Radio,
    label: translations?.menu?.operatorOverview || 'Operator Overview',
    group: 'management',
  },
  */
  /*
  {
    path: '/accommodation',
    icon: Hotel,
    label: translations?.menu?.accommodation || 'Accommodation',
    group: 'management',
  },
  */
  /*
  {
    path: '/hotel-visualization',
    icon: Eye,
    label: translations?.menu?.hotelVisualization || 'Hotel Visualization',
    group: 'management',
  },
  */
  /*
  {
    path: '/movements',
    icon: Clock,
    label: translations?.menu?.movements || 'Movements',
    group: 'management',
  },
  */
  /*
  {
    path: '/accommodationTasks',
    icon: Hotel,
    label: translations?.menu?.accommodationTasks || 'Accommodation Tasks',
    group: 'management',
  },
  */
  /*
  {
    path: '/room-upgrade',
    icon: ArrowUpCircle,
    label: translations?.menu?.roomUpgrade || 'Room Upgrades',
    group: 'management',
  },
  */
  {
    path: '/settings',
    icon: Settings,
    label: translations?.menu?.settings || 'Settings',
    group: 'settings',
  },
];

// Menu items for organizer role
const organizerMenuItems = (translations: any = {}) => [
  {
    path: '/',
    icon: LayoutDashboard,
    label: translations?.menu?.dashboard || 'Dashboard',
    group: 'dashboard',
  },
  /*
  {
    path: '/timeline',
    icon: Calendar,
    label: translations?.menu?.timeline || 'Project Timeline',
    group: 'dashboard',
  },
  */
  {
    path: '/guides',
    icon: UserCog,
    label: translations?.menu?.guides || 'Guides',
    group: 'dashboard',
  },
  {
    path: '/verification-wizard',
    icon: FileText,
    label: translations?.menu?.verificationWizard || 'Verification Wizard',
    group: 'dashboard',
  },
   {
     path: '/passport-visa',
     icon: FileImage,
     label: translations?.menu?.passportVisa || 'Passport & Visa',
     group: 'management',
   },
   
   {
     path: '/pilgrim-guide',
     icon: UserPlus,
     label: translations?.menu?.pilgrimGuide || 'Pilgrim Guide',
     group: 'management',
   },
  /*
  {
    path: '/my-operation-list',
    icon: List,
    label: translations?.menu?.operationList || 'Operation List',
    group: 'management',
  },
  */
  {
    path: '/pilgrims-informations',
    icon: Info,
    label: translations?.menu?.pilgrimsInformations || 'Pilgrims Informations',
    group: 'management',
  },
  {
    path: '/disputes',
    icon: AlertCircle,
    label: translations?.menu?.disputes || 'Disputes',
    group: 'management',
  },
  /*
  {
    path: '/operator-helper',
    icon: Radio,
    label: translations?.menu?.operatorHelper || 'Operator Helper',
    group: 'management',
  },
  */
  /*
  {
    path: '/operator-overview',
    icon: Radio,
    label: translations?.menu?.operatorOverview || 'Operator Overview',
    group: 'management',
  },
  */
  /*
  {
    path: '/room-upgrade',
    icon: ArrowUpCircle,
    label: translations?.menu?.roomUpgrade || 'Room Upgrades',
    group: 'management',
  },
  */
  /*
  {
    path: '/accommodation',
    icon: Hotel,
    label: translations?.menu?.accommodation || 'Accommodation',
    group: 'management',
  },
  */
  /*
  {
    path: '/hotel-visualization',
    icon: Eye,
    label: translations?.menu?.hotelVisualization || 'Hotel Visualization',
    group: 'management',
  },
  */
  /*
  {
    path: '/movements',
    icon: Clock,
    label: translations?.menu?.movements || 'Movements',
    group: 'management',
  },
  */
  /*
  {
    path: '/accommodationTasks',
    icon: Hotel,
    label: translations?.menu?.accommodationTasks || 'Accommodation Tasks',
    group: 'management',
  },
  */
  {
    path: '/settings',
    icon: Settings,
    label: translations?.menu?.settings || 'Settings',
    group: 'settings',
  },
];

export const getMenuItems = (role: string, translations: any = {}) => {
  switch (role) {
    case 'admin':
      return adminMenuItems(translations);
    case 'guide':
      return guideMenuItems(translations);
    case 'organizer':
      return organizerMenuItems(translations);
    default:
      return [];
  }
};

export const menuGroups = (translations: any = {}) => ({
  dashboard: translations?.menuGroups?.dashboard || 'Dashboard',
  management: translations?.menuGroups?.management || 'Management',
  linking: translations?.menuGroups?.linking || 'Linking',
  accommodation: translations?.menuGroups?.accommodation || 'Accommodation',
  settings: translations?.menuGroups?.settings || 'Settings',
});
